import { Controller } from "@hotwired/stimulus"

// Generic client-side tab/panel switching, keyed by data-tab. All panels are rendered; this
// shows the selected one. Used by the conversion-action detail panel (Classification / Alerts /
// Destinations) and the platform tab's list-mode switch (Conversion actions / Groups) — nesting
// is safe: Stimulus scopes targets to the closest controller element of the same identifier.
export default class extends Controller {
  static targets = ["tab", "panel"]
  // The tab to open on connect, set by the server when a link asks for a view (?view=). Unset
  // leaves the markup's own default, so instances nested inside a panel are unaffected. A view this
  // instance does not have (Comparison Groups exists on the Google tab only) is ignored rather than
  // activated, which would hide every panel.
  static values = { initial: String }

  connect() {
    if (this.initialValue && this.tabTargets.some((t) => t.dataset.tab === this.initialValue)) {
      this.#activate(this.initialValue)
    }
  }

  select(event) {
    this.#activate(event.currentTarget.dataset.tab)
  }

  // Param form for triggers that aren't tab buttons (e.g. a group row in the actions list
  // jumping to the Groups view): data-<identifier>-tab-param names the tab to activate.
  // Doesn't preventDefault, so a link trigger's frame navigation still proceeds.
  show(event) {
    this.#activate(event.params.tab)
  }

  #activate(tab) {
    this.tabTargets.forEach((t) => t.classList.toggle("active", t.dataset.tab === tab))
    this.panelTargets.forEach((p) => p.classList.toggle("hidden", p.dataset.tab !== tab))
  }
}
